import { CaretUp, CaretDown, CaretUpDown } from "@phosphor-icons/react";

/**
 * Clickable column header for sortable tables.
 * Props: sortKey (string), currentKey, currentDir, onClick, children, className, align.
 */
export function SortHeader({ sortKey, currentKey, currentDir, onClick, children, className = "", align = "left" }) {
  const active = sortKey === currentKey;
  const Icon = !active ? CaretUpDown : currentDir === "asc" ? CaretUp : CaretDown;
  const alignClass = align === "right" ? "text-right justify-end" : align === "center" ? "text-center justify-center" : "text-left justify-start";
  return (
    <button
      type="button"
      onClick={() => onClick(sortKey)}
      data-testid={`sort-${sortKey}`}
      className={`w-full inline-flex items-center gap-1 label-cap select-none hover:text-[var(--primary)] transition ${alignClass} ${active ? "text-[var(--primary)]" : ""} ${className}`}
    >
      <span>{children}</span>
      <Icon size={11} weight={active ? "bold" : "regular"} className="opacity-70" />
    </button>
  );
}
